<nz-layout>
  @if (title) {
    <nz-header>{{ title | translate }}</nz-header>
  }
  <nz-content>
    <nz-table #nzTable [nzData]="data || []" nzTableLayout="fixed" [nzShowPagination]="false" nzSize="small"
      nzNoResult="{{'No information for' | translate}} {{title | translate}}">
      <thead>
        <tr>
          @for (col of columns; track col) {
            <th>{{col | translate}}
              <app-tooltip [fieldName]="col" [area]="title" />
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (item of data; track item) {
          <tr>
            @for (field of rowFields; track field) {
              <td>{{ item[field] || "-"}}</td>
            }
          </tr>
        }
      </tbody>
    </nz-table>
  </nz-content>
</nz-layout>